'use client'

import { Controller } from 'react-hook-form'

import styles from './input.module.scss'

interface InputProps {
    label?: string
    type?: string
    name: string
    control: any
    error?: any | undefined
    disabled?: boolean
    placeholder: string
    isNumber?: boolean
    required?: boolean
    pattern?: any
    validate?: any
}

const CustomInput: React.FC<InputProps> = ({
    type,
    name,
    control,
    error,
    disabled,
    placeholder,
    isNumber,
    pattern,
    validate,
    required = true,
}) => {
    const handleKeyDown = (e: { key: any; preventDefault: () => void }) => {
        const regex = /^\d+$/u
        const key = e.key

        if (isNumber) {
            if (
                !regex.test(key) &&
                key !== 'Backspace' &&
                key !== 'Delete' &&
                key !== 'Ctrl' &&
                key !== 'v'
            ) {
                e.preventDefault()
            }
        }
    }

    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={{
                    required: required === true && 'Это поле обязательно к заполнению.',
                    pattern: pattern,
                    validate: validate,
                }}
                render={({ field }) => (
                    <div className={styles.inputBox}>
                        <div
                            className={styles.inputContainer}
                            style={{
                                border: error ? '1px solid red' : '',
                            }}
                        >
                            <input
                                id={name}
                                {...field}
                                type={type}
                                disabled={disabled}
                                value={field.value || ''}
                                placeholder={placeholder}
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                    </div>
                )}
            />
            {<span className={styles.errorText}>{error?.message}</span>}
        </>
    )
}

export default CustomInput
